import $ from 'jquery';
import React, { Component } from "react";
import ReactToPrint from 'react-to-print';

import PropTypes from "prop-types";

import { Grid } from "@mui/material";
import { withStyles } from "@mui/styles";
import './table.css';
import { Pokedex } from './js/pokedex';
import { Formes } from './language/formes';

import styles from "./styles";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

// Imports parser
import { generate } from "./js/parse";
import { Pokemon } from './language/pokemon';
import { Moves } from './language/moves';
import { Types } from './language/types';
import { Items } from './language/items';
import { Abilities } from './language/abilities';
import battle from "./assets/battle.JPG"

class Home extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            orientation: `@media print {@page {size: portrait;}}}`,
            visualWidth: $('#visual').width(),
            visualHeight: $('#visual').height(),
            textArea: '',
            selectedLanguage: 'EN',
            generatedPokemonEN: [],
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            topButtonVisible: false,
            topTab1: '#FF5A34',
            topTab2: 'black',
            topTab3: 'black',
            topTab4: 'black',
            topTab5: 'black',
            topTab6: 'black',
            topTab7: 'black',
            monsTab1: '#FF5A34',
            monsTab2: 'black',
            monsTab3: 'black',
            monsTab4: 'black',
            monsTab5: 'black',
            monsTab6: 'black',
            index: 0,
            direction: null
        }
    }

    handleSelectedLanguageChange = (event) => {
        this.setState({ selectedLanguage: event.target.value });
    }

    translate = () => {
        let mons = [];
        if (this.state.monsTab4 === 'black') {
            if (this.state.generatedPokemonEN.length === 0) {
                for (let i = 0; i < 6; i++) {
                    let species, genderforme, ability, teratype, heldItem, move1, move2, move3, move4;
                    species = genderforme = ability = teratype = heldItem = move1 = move2 = move3 = move4 = '';

                    if (this.state.monsTab3 !== 'black') {
                        species = $('.pkmnCard').eq(i).find("#visualPokemonText").text();
                        ability = $('.pkmnCard').eq(i).find("#visualAbilityText").text();
                        teratype = $('.pkmnCard').eq(i).find("#teratype").text();
                        heldItem = $('.pkmnCard').eq(i).find("#visualHeldItemText").text();
                        move1 = $('.pkmnCard').eq(i).find("#visualMove1").text();
                        move2 = $('.pkmnCard').eq(i).find("#visualMove2").text();
                        move3 = $('.pkmnCard').eq(i).find("#visualMove3").text();
                        move4 = $('.pkmnCard').eq(i).find("#visualMove4").text();
                    } else {
                        species = $('.ptable').eq(i).find("#pokemon").text();
                        ability = $('.ptable').eq(i).find("#ability").text();
                        teratype = $('.ptable').eq(i).find("#teratype").text();
                        heldItem = $('.ptable').eq(i).find("#heldItem").text();
                        move1 = $('.ptable').eq(i).find("#move1").text();
                        move2 = $('.ptable').eq(i).find("#move2").text();
                        move3 = $('.ptable').eq(i).find("#move3").text();
                        move4 = $('.ptable').eq(i).find("#move4").text();
                    }
                    if (species.slice(-2) == '-M') {
                        species = species.slice(0, -2);
                        genderforme = '-M';
                    } else if (species.slice(-2) == '-F') {
                        species = species.slice(0, -2);
                        genderforme = '-F';
                    }
                    if (Pokemon[species]) {
                        console.log(Pokemon[species]);
                        if (genderforme !== '' && this.state.selectedLanguage === 'EN') {
                            $('.ptable').eq(i).find("#pokemon").text(Pokemon[species][0][this.state.selectedLanguage] + genderforme);
                            $('.pkmnCard').eq(i).find("#visualPokemonText").text(Pokemon[species][0][this.state.selectedLanguage] + genderforme);
                        } else {
                            $('.ptable').eq(i).find("#pokemon").text(Pokemon[species][0][this.state.selectedLanguage]);
                            $('.pkmnCard').eq(i).find("#visualPokemonText").text(Pokemon[species][0][this.state.selectedLanguage]);
                        }
                    } else {
                        if (Formes[species]) {
                            let converted = species.toLowerCase().replace(/[ '-]/g, '');
                            if (this.state.selectedLanguage !== 'EN' && Pokedex[converted]) {
                                $('.ptable').eq(i).find("#pokemon").text(Pokemon[Pokedex[converted].baseSpecies][0][this.state.selectedLanguage] + '\n(' + Formes[species][this.state.selectedLanguage] + ')');
                                $('.pkmnCard').eq(i).find("#visualPokemonText").text(Pokemon[Pokedex[converted].baseSpecies][0][this.state.selectedLanguage]);
                            } else if (this.state.selectedLanguage !== 'EN') {
                                $('.ptable').eq(i).find("#pokemon").text(Pokemon['Tatsugiri'][0][this.state.selectedLanguage] + '\n(' + Formes[species][this.state.selectedLanguage] + ')');
                                $('.pkmnCard').eq(i).find("#visualPokemonText").text(Pokemon['Tatsugiri'][0][this.state.selectedLanguage]);
                            }
                        }
                        // let converted = species.toLowerCase().replace(/[ '-]/g, '');
                        // if (Pokedex[converted]){
                        //     if (this.state.selectedLanguage !== 'EN') {
                        //         $('.ptable').eq(i).find("#pokemon").text(Pokemon[Pokedex[converted].baseSpecies][0][this.state.selectedLanguage] + genderforme);
                        //         $('.pkmnCard').eq(i).find("#visualPokemonText").text(Pokemon[Pokedex[converted].baseSpecies][0][this.state.selectedLanguage] + genderforme);
                        //     } 
                        // }
                    }

                    if (Abilities[ability]) {
                        $('.ptable').eq(i).find("#ability").text(Abilities[ability][0][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(i).find("#visualAbilityText").text(Abilities[ability][0][this.state.selectedLanguage]);
                    }
                    if (Types[teratype]) {
                        $('.ptable').eq(i).find("#teratype").text(Types[teratype][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(i).find("#teratype").text(Types[teratype][this.state.selectedLanguage]);
                    }
                    if (Items[heldItem]) {
                        $('.ptable').eq(i).find("#heldItem").text(Items[heldItem][0][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(i).find("#visualHeldItemText").text(Items[heldItem][0][this.state.selectedLanguage]);
                    }
                    if (Moves[move1]) {
                        $('.ptable').eq(i).find("#move1").text(Moves[move1][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(i).find("#visualMove1").text(Moves[move1][this.state.selectedLanguage]);
                    }
                    if (Moves[move2]) {
                        $('.ptable').eq(i).find("#move2").text(Moves[move2][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(i).find("#visualMove2").text(Moves[move2][this.state.selectedLanguage]);
                    }
                    if (Moves[move3]) {
                        $('.ptable').eq(i).find("#move3").text(Moves[move3][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(i).find("#visualMove3").text(Moves[move3][this.state.selectedLanguage]);
                    }
                    if (Moves[move4]) {
                        $('.ptable').eq(i).find("#move4").text(Moves[move4][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(i).find("#visualMove4").text(Moves[move4][this.state.selectedLanguage]);
                    }
                    mons.push(
                        {
                            species: species,
                            genderforme: genderforme,
                            ability: ability,
                            teratype: teratype,
                            heldItem: heldItem,
                            move1: move1,
                            move2: move2,
                            move3: move3,
                            move4: move4,
                        }
                    );
                }
                this.setState({ generatedPokemonEN: mons })
            } else {
                for (let k = 0; k < 6; k++) {
                    if (Pokemon[this.state.generatedPokemonEN[k].species]) {
                        if (this.state.generatedPokemonEN[k].genderforme !== '' && this.state.selectedLanguage === 'EN') {
                            $('.ptable').eq(k).find("#pokemon").text(Pokemon[this.state.generatedPokemonEN[k].species][0][this.state.selectedLanguage] + this.state.generatedPokemonEN[k].genderforme);
                            $('.pkmnCard').eq(k).find("#visualPokemonText").text(Pokemon[this.state.generatedPokemonEN[k].species][0][this.state.selectedLanguage] + this.state.generatedPokemonEN[k].genderforme);
                        } else {
                            $('.ptable').eq(k).find("#pokemon").text(Pokemon[this.state.generatedPokemonEN[k].species][0][this.state.selectedLanguage]);
                            $('.pkmnCard').eq(k).find("#visualPokemonText").text(Pokemon[this.state.generatedPokemonEN[k].species][0][this.state.selectedLanguage]);
                        }
                    } else {
                        console.log('hello')
                        if (Formes[this.state.generatedPokemonEN[k].species]) {
                            let converted = this.state.generatedPokemonEN[k].species.toLowerCase().replace(/[ '-]/g, '');
                            if (this.state.selectedLanguage !== 'EN' && Pokedex[converted]) {
                                $('.ptable').eq(k).find("#pokemon").text(Pokemon[Pokedex[converted].baseSpecies][0][this.state.selectedLanguage] + '\n(' + Formes[this.state.generatedPokemonEN[k].species][this.state.selectedLanguage] + ')');
                                $('.pkmnCard').eq(k).find("#visualPokemonText").text(Pokemon[Pokedex[converted].baseSpecies][0][this.state.selectedLanguage]);
                            } else if (this.state.selectedLanguage !== 'EN') {
                                $('.ptable').eq(k).find("#pokemon").text(Pokemon['Tatsugiri'][0][this.state.selectedLanguage] + '\n(' + Formes[this.state.generatedPokemonEN[k].species][this.state.selectedLanguage] + ')');
                                $('.pkmnCard').eq(k).find("#visualPokemonText").text(Pokemon['Tatsugiri'][0][this.state.selectedLanguage]);
                            }
                        }
                        // let converted = this.state.generatedPokemonEN[k].species.toLowerCase().replace(/[ '-]/g, '');
                        // console.log(converted);
                        // if (Pokedex[converted]){
                        //     if (this.state.selectedLanguage !== 'EN') {
                        //         $('.ptable').eq(k).find("#pokemon").text(Pokemon[Pokedex[converted].baseSpecies][0][this.state.selectedLanguage] + this.state.generatedPokemonEN[k].genderforme);
                        //         $('.pkmnCard').eq(k).find("#visualPokemonText").text(Pokemon[Pokedex[converted].baseSpecies][0][this.state.selectedLanguage] + this.state.generatedPokemonEN[k].genderforme);
                        //     } 
                        // }
                    }
                    if (Abilities[this.state.generatedPokemonEN[k].ability]) {
                        $('.ptable').eq(k).find("#ability").text(Abilities[this.state.generatedPokemonEN[k].ability][0][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(k).find("#visualAbilityText").text(Abilities[this.state.generatedPokemonEN[k].ability][0][this.state.selectedLanguage]);
                    }
                    if (Types[this.state.generatedPokemonEN[k].teratype]) {
                        $('.ptable').eq(k).find("#teratype").text(Types[this.state.generatedPokemonEN[k].teratype][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(k).find("#teratype").text(Types[this.state.generatedPokemonEN[k].teratype][this.state.selectedLanguage]);
                    }
                    if (Items[this.state.generatedPokemonEN[k].heldItem]) {
                        $('.ptable').eq(k).find("#heldItem").text(Items[this.state.generatedPokemonEN[k].heldItem][0][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(k).find("#visualHeldItemText").text(Items[this.state.generatedPokemonEN[k].heldItem][0][this.state.selectedLanguage]);
                    }
                    if (Moves[this.state.generatedPokemonEN[k].move1] && Moves[this.state.generatedPokemonEN[k].move2] && Moves[this.state.generatedPokemonEN[k].move3] && Moves[this.state.generatedPokemonEN[k].move4]) {
                        $('.ptable').eq(k).find("#move1").text(Moves[this.state.generatedPokemonEN[k].move1][this.state.selectedLanguage]);
                        $('.ptable').eq(k).find("#move2").text(Moves[this.state.generatedPokemonEN[k].move2][this.state.selectedLanguage]);
                        $('.ptable').eq(k).find("#move3").text(Moves[this.state.generatedPokemonEN[k].move3][this.state.selectedLanguage]);
                        $('.ptable').eq(k).find("#move4").text(Moves[this.state.generatedPokemonEN[k].move4][this.state.selectedLanguage]);

                        $('.pkmnCard').eq(k).find("#visualMove1").text(Moves[this.state.generatedPokemonEN[k].move1][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(k).find("#visualMove2").text(Moves[this.state.generatedPokemonEN[k].move2][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(k).find("#visualMove3").text(Moves[this.state.generatedPokemonEN[k].move3][this.state.selectedLanguage]);
                        $('.pkmnCard').eq(k).find("#visualMove4").text(Moves[this.state.generatedPokemonEN[k].move4][this.state.selectedLanguage]);
                    } else {
                        // alert('Error! Either your move input is invalid, or the move database is invalid! (2)')
                    }
                }
            }
        }
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
        this.setState({ visualWidth: $('#visual').width() });
        this.setState({ visualHeight: $('#visual').height() });
    }

    handleOrientation = (e) => {
        if (this.state.monsTab3 !== 'black') {
            this.setState({ orientation: `@media print {@page {size: landscape;}}}` });
        } else {
            this.setState({ orientation: `@media print {@page {size: portrait;}}}` });
        }
    }

    toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop
        if (scrolled > 300) {
            this.setState({ topButtonVisible: true });
        }
        else if (scrolled <= 300) {
            this.setState({ topButtonVisible: false });
        }
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            /* you can also use 'auto' behaviour
               in place of 'smooth' */
        });
    };

    changeMainTabColour = (index, lastIndex) => {
        this.setState({ [`topTab${index + 1}`]: '#FF5A34', [`topTab${lastIndex + 1}`]: 'black' });
    }

    changeMonsTabColour = (index, lastIndex) => {
        if (index !== lastIndex) {
            this.setState({ [`monsTab${index + 1}`]: '#FF5A34', [`monsTab${lastIndex + 1}`]: 'black' });
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        window.addEventListener('scroll', this.toggleVisible);
        window.addEventListener("click", this.handleOrientation);
    }

    componentWillUnmount() {
        window.addEventListener("resize", this.handleResize);
    }

    // Components
    publicOutputTable = () => {
        return (
            <table id="outputTable">
                <tbody>

                    <tr>
                        <td className="space-entry">
                            <table className="ptable">
                                <tbody>
                                    <tr>
                                        <th className="label">Pokemon</th>
                                        <td colSpan="2" id="pokemon" className="value">&nbsp;</td>
                                        {/* <td className="label"></td> */}
                                        <td id="gender" className="value">
                                            <img alt="gender" width="70px" src="images/gender_NA.png" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="label">Tera Type</th>
                                        <td id="teratype" className="value">&nbsp;</td>
                                        <td className="label">Lv</td>
                                        <td id="level" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Ability</th>
                                        <td id="ability" className="value">&nbsp;</td>
                                        <td className="label">HP</td>
                                        <td id="hp" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Held Item</th>
                                        <td id="heldItem" className="value">&nbsp;</td>
                                        <td className="label">Att</td>
                                        <td id="atk" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 1</th>
                                        <td id="move1" className="value">&nbsp;</td>
                                        <td className="label">Def</td>
                                        <td id="def" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 2</th>
                                        <td id="move2" className="value">&nbsp;</td>
                                        <td className="label">S. Att</td>
                                        <td id="spatk" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 3</th>
                                        <td id="move3" className="value">&nbsp;</td>
                                        <td className="label">S. Def</td>
                                        <td id="spdef" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 4</th>
                                        <td id="move4" className="value">&nbsp;</td>
                                        <td className="label">Spe</td>
                                        <td id="spe" className="value"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td className="space-entry">
                            <table className="ptable">
                                <tbody>
                                    <tr>
                                        <th className="label">Pokemon</th>
                                        <td colSpan="2" id="pokemon" className="value">&nbsp;</td>
                                        {/* <td className="label"></td> */}
                                        <td id="gender" className="value">
                                            <img alt="gender" width="70px" src="images/gender_NA.png" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="label">Tera Type</th>
                                        <td id="teratype" className="value">&nbsp;</td>
                                        <td className="label">Lv</td>
                                        <td id="level" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Ability</th>
                                        <td id="ability" className="value">&nbsp;</td>
                                        <td className="label">HP</td>
                                        <td id="hp" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Held Item</th>
                                        <td id="heldItem" className="value">&nbsp;</td>
                                        <td className="label">Att</td>
                                        <td id="atk" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 1</th>
                                        <td id="move1" className="value">&nbsp;</td>
                                        <td className="label">Def</td>
                                        <td id="def" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 2</th>
                                        <td id="move2" className="value">&nbsp;</td>
                                        <td className="label">S. Att</td>
                                        <td id="spatk" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 3</th>
                                        <td id="move3" className="value">&nbsp;</td>
                                        <td className="label">S. Def</td>
                                        <td id="spdef" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 4</th>
                                        <td id="move4" className="value">&nbsp;</td>
                                        <td className="label">Spe</td>
                                        <td id="spe" className="value"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                </tbody>
            </table>
        );
    }

    privateOutputTable = () => {
        return (
            <table id="outputTable">
                <tbody>
                    <tr>
                        <td className="space-entry">
                            <table className="ptable">
                                <tbody>
                                    <tr>
                                        <th className="label">Pokemon</th>
                                        <td colSpan="2" id="pokemon" className="value">&nbsp;</td>
                                        <td id="gender" className="value">
                                            <img alt="gender" width="70px" src="images/gender_NA.png" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="label">Tera Type</th>
                                        <td id="teratype" className="value">&nbsp;</td>
                                        <td className="label">Lv</td>
                                        <td id="level" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Ability</th>
                                        <td colSpan="3" id="ability" className="value">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th className="label">Held Item</th>
                                        <td colSpan="3" id="heldItem" className="value">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 1</th>
                                        <td colSpan="3" id="move1" className="value">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 2</th>
                                        <td colSpan="3" id="move2" className="value">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 3</th>
                                        <td colSpan="3" id="move3" className="value">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 4</th>
                                        <td colSpan="3" id="move4" className="value">&nbsp;</td>
                                    </tr>
                                </tbody>

                            </table>
                        </td>
                        <td className="space-entry">
                            <table className="ptable">
                                <tbody>
                                    <tr>
                                        <th className="label">Pokemon</th>
                                        <td colSpan="2" id="pokemon" className="value">&nbsp;</td>
                                        <td id="gender" className="value">
                                            <img alt="gender" width="70px" src="images/gender_NA.png" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="label">Tera Type</th>
                                        <td id="teratype" className="value">&nbsp;</td>
                                        <td className="label">Lv</td>
                                        <td id="level" className="value"></td>
                                    </tr>
                                    <tr>
                                        <th className="label">Ability</th>
                                        <td colSpan="3" id="ability" className="value">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th className="label">Held Item</th>
                                        <td colSpan="3" id="heldItem" className="value">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 1</th>
                                        <td colSpan="3" id="move1" className="value">&nbsp;</td>

                                    </tr>
                                    <tr>
                                        <th className="label">Move 2</th>
                                        <td colSpan="3" id="move2" className="value">&nbsp;</td>

                                    </tr>
                                    <tr>
                                        <th className="label">Move 3</th>
                                        <td colSpan="3" id="move3" className="value">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <th className="label">Move 4</th>
                                        <td colSpan="3" id="move4" className="value">&nbsp;</td>
                                    </tr>
                                </tbody>

                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    publicVisual = () => {
        return (<div style={{ display: 'flex', flex: 2, backgroundColor: 'transparent', marginTop: '1%' }}>
            <div className="pkmnCard" style={{ flex: 1, display: 'flex', background: `rgba(24, 66, 108, 0.8)`, padding: '1%', paddingRight: 0 }}>
                <div style={{ flex: 4, display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                    <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <p id="visualPokemonText" style={{ color: '#FFF' }}></p>
                    </div>
                    <div id="visualLevel" style={{ display: 'flex', flexDirection: 'row', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <p id="visualLevelText" style={{ color: '#FFF', marginTop: '1%' }}></p>
                        <div id="visualGender" style={{ display: 'flex' }} />
                    </div>
                    <div id="visualAbility" style={{ display: 'flex', flexDirection: 'row', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <p id="visualAbilityText" style={{ color: '#FFF' }}></p>
                    </div>
                    <div id="visualHeldItem" style={{ display: 'flex', flexDirection: 'row', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <p id="visualHeldItemText" style={{ color: '#FFF' }}></p>
                    </div>
                </div>
                <div style={{ flex: 2, display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                    <div id="visualPkmnTypes" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }} />
                    <div id="visualPkmnImg" />
                </div>
                <div style={{ width: '0.2vw', backgroundColor: '#FFF', }}></div>
                <div style={{ flex: 5, display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                    <div className="visualMove" style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <div id="visualMoveType1" style={{ marginLeft: '5%', marginRight: '5%', display: 'flex' }} />
                        <p id="visualMove1" style={{ color: '#FFF', marginTop: '1%' }}></p>
                    </div>
                    <div className="visualMove" style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <div id="visualMoveType2" style={{ marginLeft: '5%', marginRight: '5%', display: 'flex' }} />
                        <p id="visualMove2" style={{ color: '#FFF', marginTop: '1%' }} />
                    </div>
                    <div className="visualMove" style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <div id="visualMoveType3" style={{ marginLeft: '5%', marginRight: '5%', display: 'flex' }} />
                        <p id="visualMove3" style={{ color: '#FFF', marginTop: '1%' }} />
                    </div>
                    <div className="visualMove" style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <div id="visualMoveType4" style={{ marginLeft: '5%', marginRight: '5%', display: 'flex' }} />
                        <p id="visualMove4" style={{ color: '#FFF', marginTop: '1%' }} />
                    </div>
                </div>
            </div>
            <div className="pkmnCard" style={{ flex: 1, display: 'flex', background: `rgba(24, 66, 108, 0.8)`, padding: '1%', paddingRight: 0, marginLeft: '2%' }}>
                <div style={{ flex: 4, display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                    <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <p id="visualPokemonText" style={{ color: '#FFF' }}></p>
                    </div>
                    <div id="visualLevel" style={{ display: 'flex', flexDirection: 'row', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <p id="visualLevelText" style={{ color: '#FFF', marginTop: '1%' }}></p>
                        <div id="visualGender" style={{ display: 'flex' }} />
                    </div>
                    <div id="visualAbility" style={{ display: 'flex', flexDirection: 'row', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <p id="visualAbilityText" style={{ color: '#FFF' }}></p>
                    </div>
                    <div id="visualHeldItem" style={{ display: 'flex', flexDirection: 'row', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <p id="visualHeldItemText" style={{ color: '#FFF' }}></p>
                    </div>
                </div>
                <div style={{ flex: 2, display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                    <div id="visualPkmnTypes" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }} />
                    <div id="visualPkmnImg" />
                </div>
                <div style={{ width: '0.2vw', backgroundColor: '#FFF', }}></div>
                <div style={{ flex: 5, display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                    <div className="visualMove" style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <div id="visualMoveType1" style={{ marginLeft: '5%', marginRight: '5%', display: 'flex' }} />
                        <p id="visualMove1" style={{ color: '#FFF', marginTop: '1%' }}></p>
                    </div>
                    <div className="visualMove" style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <div id="visualMoveType2" style={{ marginLeft: '5%', marginRight: '5%', display: 'flex' }} />
                        <p id="visualMove2" style={{ color: '#FFF', marginTop: '1%' }} />
                    </div>
                    <div className="visualMove" style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <div id="visualMoveType3" style={{ marginLeft: '5%', marginRight: '5%', display: 'flex' }} />
                        <p id="visualMove3" style={{ color: '#FFF', marginTop: '1%' }} />
                    </div>
                    <div className="visualMove" style={{ display: 'flex', flexDirection: 'row', width: '100%', textAlign: 'left', justifyContent: 'left', alignItems: 'center', flex: 1 }}>
                        <div id="visualMoveType4" style={{ marginLeft: '5%', marginRight: '5%', display: 'flex' }} />
                        <p id="visualMove4" style={{ color: '#FFF', marginTop: '1%' }} />
                    </div>
                </div>
            </div>
        </div>);
    }

    render() {
        const { classes } = this.props;
        return (
            <div style={{ flex: 1 }}>
                <style type="text/css" scoped>{this.state.orientation}</style>
                <button style={{ display: this.state.topButtonVisible ? 'block' : 'none' }} onClick={this.scrollToTop} className={classes.topButton}>Top</button>
                <div className={classes.root}>
                    <Tabs onSelect={(index, lastIndex) => this.changeMainTabColour(index, lastIndex)} style={{}}>
                        <TabList style={{ textAlign: 'left', display: 'block', alignItems: 'left', padding: 64, paddingTop: 32, paddingBottom: 0, width: "100%" }}>
                            <Tab id="mainTab1" style={{ color: this.state.topTab1 }}>Showdown to Private & Public Teamsheet Beta</Tab>
                            <Tab id="mainTab2" style={{ color: this.state.topTab2 }}>Private & Public Teamsheet Maker (Coming soon!)</Tab>
                        </TabList>

                        <TabPanel>
                            <Grid container style={{ textAlign: 'left', alignItems: 'left', padding: 64, paddingTop: 32, paddingBottom: 0, }}>
                                <Grid id="formatting" xs={12} md={6}>
                                    Standard Pokémon Showdown format.
                                    <p>Team Member 1 (M) @ Item</p>
                                    <p>Ability: Levitate</p>
                                    <p>Level: 50</p>
                                    <p>Tera Type: Dark</p>
                                    <p>EVs: 4 HP / 4 Atk / 4 Def / 4 SpA / 4 SpD / 4 Spe</p>
                                    <p>Quirky Nature</p>
                                    <p>IVs: 0 Atk / 0 Spe</p>
                                    <p> - Move 1</p>
                                    <p> - Move 2</p>
                                    <p> - Move 3</p>
                                    <p> - Move 4</p>
                                    ... and continue with the rest of the team.
                                </Grid>
                                <Grid id="textbox" xs={12} md={6}>
                                    <p>
                                        VGC 2023 Teamsheet Generator by <a href="https://twitter.com/tehdrink" target="_blank" rel="noreferrer">Kester Teh (TehDrink)</a>.
                                        <br />
                                        <br />
                                        Support me with a <a href="https://ko-fi.com/tehdrink" target="_blank" rel="noreferrer">coffee! ☕️</a>
                                        <br />
                                        <br />
                                        This is a fork of the Teamsheet generator originally by <a href="https://twitter.com/squirrelboyVGC" target="_blank" rel="noreferrer">Jake White</a>.
                                        <br />
                                        Regex/styling guide taken from <a href="https://github.com/Tapin42/premier_team_list" target="_blank" rel="noreferrer">Tapin</a>.
                                        <br />
                                        <br />
                                        Do note that this project is still a <b>work in progress</b> (theres still loads to do!!) and there are bound to be plenty of bugs!
                                        <br />
                                        <br />
                                        If you do spot any or want to leave feedback, do send me a message on <a href="https://twitter.com/tehdrink" target="_blank" rel="noreferrer">Twitter</a>!
                                        <br />
                                        <br />
                                        Editing and Checking the teamsheet is <span style={{ color: "red" }}><b>your responsibility</b></span>. The generator and I will not be responsible for any issues that may arise due to an error/misjudgement during play.
                                        <br />
                                        <br />
                                        <u>Not yet implemented:</u>
                                        <br />
                                        1. Pokemon Forme validation + language other than English.
                                        <br />
                                        2. System language support
                                        <br />
                                        3. Dynamic styling + Mobile Support + Print fixes
                                        <br />
                                        <br />
                                        A <b>BIG</b> Special Thanks for the resources and data!
                                        <br />
                                        1. <a href="https://twitter.com/RedsilverFR" target="_blank" rel="noreferrer">Hippolyte Bernard (@RedsilverFR)</a>
                                        <br />
                                        2. <a href="https://twitter.com/Kaphotics" target="_blank" rel="noreferrer">Kurt (@Kaphotics)</a>
                                        <br />
                                        3. <a href="https://twitter.com/mattyoukhana_" target="_blank" rel="noreferrer">Matt (@mattyoukhana_)</a>
                                        <br />
                                        4. <a href="https://github.com/smogon/pokemon-showdown" target="_blank" rel="noreferrer">Pokémon Showdown!</a>
                                        <br />
                                        Trello Board: <a href="https://trello.com/b/it43yONX/poketranslator" target="_blank" rel="noreferrer">https://trello.com/b/it43yONX/poketranslator</a>
                                        <br />
                                        <br />
                                    </p>

                                    <p>1. Pick the language of the teamsheet below!</p>
                                    <select style={{ width: '200px', height: '44px' }} onChange={this.handleSelectedLanguageChange} value={this.state.selectedLanguage} name="language" id="language">
                                        <option value="EN">English</option>
                                        <option value="JP">日本語</option>
                                        <option value="FR">Français</option>
                                        <option value="DE">Nederlands</option>
                                        <option value="ES">Español</option>
                                        <option value="IT">Italiano</option>
                                        <option value="KOR">한국어</option>
                                        <option value="CHS">简体中文</option>
                                        <option value="CHT">中文</option>
                                    </select>
                                    {/* </div> */}
                                    <p>2. Paste your Showdown! team <span style={{ color: "red" }}>here</span>:</p>
                                    <textarea id="roster" rows="30" cols="50" style={{ height: 400, width: '100%' }} value={this.state.textArea} onChange={(e) => { this.setState({ textArea: e.target.value }) }}></textarea>
                                    <br />
                                    <p>3. Click on Generate to Generate the selected item!</p>
                                    <p><span style={{ color: "red" }}>*Note:</span> Please use the print button to print, do not use the browser's default print controls (CTRL+P/CMD+P)</p>
                                    <p><span style={{ color: "red" }}>*Note:</span> For the best print result, please use Landscape for the Game Visual prints, and Portrait for the rest.</p>
                                    <input style={{ width: '200px', height: '44px' }} type="button" id="OK" value="Generate" disabled={(this.state.textArea === '') ? true : false} onClick={() => {
                                        this.setState({ generatedPokemonEN: [] })
                                        this.translate();
                                    }}></input>
                                    <ReactToPrint
                                        onBeforePrint={() => {
                                            // Sets the print mode for printers.
                                            if (this.state.monsTab3 !== 'black') {
                                                this.setState({ orientation: `@media print {@page {size: landscape;}}}` })
                                            } else {
                                                this.setState({ orientation: `@media print {@page {size: portrait;}}}` })
                                            }
                                        }}
                                        trigger={() => {
                                            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                                            // to the root node of the returned component as it will be overwritten.
                                            return <input style={{ width: '200px', height: '44px' }} type="button" id="print" value="Print"></input>;
                                        }}
                                        content={() => this.componentRef}
                                    // pageStyle={`@media print {
                                    //     @page { size: landscape; }
                                    //   }`}
                                    />
                                </Grid>
                            </Grid>
                            <Tabs onSelect={(index, lastIndex) => { this.changeMonsTabColour(index, lastIndex) }} style={{}}>
                                <TabList style={{ textAlign: 'left', display: 'block', alignItems: 'left', padding: 64, paddingTop: 32, paddingBottom: 0, width: "100%" }}>
                                    <Tab id="mainTab1Tab1" style={{ color: this.state.topTab1 }}>
                                        <p id="monsTab1" style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents', color: this.state.monsTab1 }}>Private Teamsheet (Form)</p>
                                    </Tab>
                                    <Tab id="mainTab1Tab2" style={{ color: this.state.topTab2 }}>
                                        <p id="monsTab2" style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents', color: this.state.monsTab2 }}>Public Teamsheet (Form)</p>
                                    </Tab>
                                    <Tab id="mainTab1Tab3" style={{ color: this.state.topTab3 }}>
                                        <p id="monsTab3" style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents', color: this.state.monsTab3 }}>Public Teamsheet (Game Visual)</p>
                                    </Tab>
                                    <Tab id="mainTab1Tab4" style={{ color: this.state.topTab4 }}>
                                        <p id="monsTab4" style={{ marginTop: 'auto', verticalAlign: 'middle', display: 'contents', color: this.state.monsTab4 }}>Public Text (English)</p>
                                    </Tab>
                                </TabList>
                                <TabPanel>
                                    <Grid container style={{ justifyContent: 'center', overflow: 'scroll' }}>
                                        <Grid container ref={el => (this.componentRef = el)} style={{ width: "100%", justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                                            <Grid container className="printHead" style={{ flexDirection: 'row' }}>
                                                <Grid xs={12} id="printTitle">Pokémon Video Game Private Team List</Grid>
                                                <Grid container className="top">
                                                    <Grid xs={6} id="primary">
                                                        <div className="namecol" style={{ marginLeft: 'auto', marginRight: 0 }}>
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">Name:</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">In-Game Name:</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">Player ID:</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">Date of Birth:</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>
                                                            <div className="field" style={{ marginBottom: 36 }}>
                                                                <div className="row">
                                                                    <div className="label">
                                                                        Age Division: Juniors&nbsp;
                                                                        <input type="checkbox" />&nbsp;
                                                                        Seniors&nbsp;
                                                                        <input type="checkbox" />&nbsp;
                                                                        Masters&nbsp;
                                                                        <input type="checkbox" />&nbsp;
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid xs={6} id="secondary">
                                                        <div className="namecol">
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">Event Dates</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">Event Name:</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">Switch Profile Name:</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">Battle Team:</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="cartlabel"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {this.publicOutputTable()}
                                            {this.publicOutputTable()}
                                            {this.publicOutputTable()}
                                            <p id="warning">
                                                <u><b>Notes:</b></u>
                                                <br />
                                                Please fill out this Team List using the language to which the player's game is set.<br />
                                                <br />
                                                All Pokémon must be listed exactly as the appear in the Battle Team, <b>at the level they are in the game.</b>
                                                If they are not, penalties may be incurred.<br />
                                                <br />
                                                If your Pokémon is of a particular <b>Forme</b> (e.g. Rotom-Wash), or a <b>Regional Variant</b> (e.g. Galarian
                                                Rapidash) include this in the "Pokémon" field<br />
                                            </p>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel>
                                    <Grid container style={{ justifyContent: 'center', overflow: 'scroll' }}>
                                        <Grid container ref={el => (this.componentRef = el)} style={{ width: "100%", justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                                            <Grid container className="printHead" style={{ flexDirection: 'row', marginBottom: 36 }}>
                                                <Grid xs={12} id="printTitle">Pokémon Video Game Public Team List</Grid>
                                                <Grid container className="top">
                                                    <Grid xs={6} id="primary">
                                                        <div className="namecol" style={{ marginLeft: 'auto', marginRight: 0 }}>
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">Name:</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">In-Game Name:</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </Grid>
                                                    <Grid xs={6} id="secondary">
                                                        <div className="namecol">
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">Event Dates</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>
                                                            <div className="field">
                                                                <div className="row">
                                                                    <div className="label">Event Name:</div>
                                                                    <div className="data"></div>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            {this.privateOutputTable()}
                                            {this.privateOutputTable()}
                                            {this.privateOutputTable()}
                                            <p id="warning">
                                                <u><b>Notes:</b></u>
                                                <br />
                                                Please fill out this Team List using the language to which the player's game is set.<br />
                                                <br />
                                                All Pokémon must be listed exactly as the appear in the Battle Team, <b>at the level they are in the game.</b>
                                                If they are not, penalties may be incurred.<br />
                                                <br />
                                                If your Pokémon is of a particular <b>Forme</b> (e.g. Rotom-Wash), or a <b>Regional Variant</b> (e.g. Galarian
                                                Rapidash) include this in the "Pokémon" field<br />
                                            </p>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel>
                                    <Grid container style={{ justifyContent: 'center', paddingLeft: 64, paddingRight: 64, marginRight: 64 }}>
                                        <div ref={el => (this.componentRef = el)} style={{ display: "inline-flex", maxHeight: "100%", minWidth: '493px' }}>
                                            <img alt="visual" id="visual" src={battle} style={{ width: "100%" }} />
                                            {/* Logic Container */}
                                            <div id="logicContainer" style={{ display: 'flex', flex: 1, flexDirection: 'column', height: $('#visual').height(), width: $('#visual').width(), position: 'absolute', padding: '2%' }}>
                                                <div style={{ flex: 1, backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', }}>
                                                        <div style={{ display: 'flex', flex: 11, flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                                                            <div style={{ width: '0.15vw', height: '2vw', backgroundColor: '#FFF' }}></div>
                                                            <input className="visualTextBox" type={'text'} style={{ width: '100%', marginLeft: '1%' }} placeholder="Event Name"></input>
                                                        </div>
                                                        <div style={{ display: 'flex', flex: 8, flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                                                            <div style={{ width: '0.15vw', height: '2vw', backgroundColor: '#FFF' }}></div>
                                                            <input className="visualTextBox" type={'text'} style={{ width: '100%', marginLeft: '1%' }} placeholder="Your Name"></input>
                                                        </div>
                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                                                        <p style={{ color: '#FFF', marginLeft: '1%', marginRight: '1%', marginTop: '1%' }}>Event Date</p>
                                                        <div style={{ width: '0.15vw', height: '2vw', backgroundColor: '#FFF' }}></div>
                                                        <input className="visualTextBox" type={'text'} style={{ marginLeft: '1%', width: 'auto', textAlign: 'end' }} maxLength={8} size={10} placeholder="DD/MM/YY"></input>
                                                    </div>
                                                </div>
                                                {this.publicVisual()}
                                                {this.publicVisual()}
                                                {this.publicVisual()}
                                            </div>
                                        </div>
                                    </Grid>
                                </TabPanel>
                                <TabPanel>
                                    <Grid container style={{ justifyContent: 'center' }}>
                                        <div style={{ paddingBottom: 64, marginLeft: 64, marginRight: 64, width: "100%", justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                                            <div id="printTitle">Pokémon Video Game Public Team List Text</div>
                                            <textarea id="rosterpublic" disabled rows="30" cols="50" style={{ height: 400, width: '100%', maxWidth: '600px' }}></textarea>
                                        </div>
                                    </Grid>
                                </TabPanel>
                            </Tabs>
                        </TabPanel>

                        <TabPanel>
                            <Grid container>
                                <div style={{ padding: 64 }}>
                                    <h2 style={{ textAlign: 'left', height: this.state.windowHeight }}>Coming soon!</h2>
                                </div>
                            </Grid>
                        </TabPanel>
                    </Tabs>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(Home);
